module.exports = __webpack_public_path__ + "img/gate-vertical.c1e6886a.png";